import type { ResourcePriceByTimeSteps } from "@@/shared/acquire/resource-price/resource-price-by-time-step";
import { resourcePriceByTimeStepsZodSchema } from "@@/shared/acquire/resource-price/resource-price-by-time-step";
import { z } from "zod";
import type { ResourcePriceByTime } from "./resource-price-by-time";
import { resourcePriceByTimeZodSchema } from "./resource-price-by-time";
import type { ResourcePriceFixed } from "./resource-price-fixed";
import { resourcePriceFixedZodSchema } from "./resource-price-fixed";

type ResourcePrice =
    | ResourcePriceFixed
    | ResourcePriceByTime
    | ResourcePriceByTimeSteps;
type ResourcePriceType = ResourcePrice["_type"];

const resourcePriceZodSchema = z.union([
    resourcePriceFixedZodSchema,
    resourcePriceByTimeZodSchema,
    resourcePriceByTimeStepsZodSchema,
]);

export { resourcePriceZodSchema };
export type { ResourcePrice, ResourcePriceType };
